import { sendEvent } from "@JohnLewisPartnership/experiments-utils";

/**
 * Higher-order function that wraps an onOpen callback to dispatch analytics events
 * for side drawer interactions. This ensures all side drawer opens are tracked
 * consistently with the same event pattern used by accordions.
 */
export function withSideDrawerAnalytics(
  name: string,
  onOpen: () => void,
): () => void {
  return () => {
    sendEvent(`WPDP | Accordion Opened | ${name}`);
    onOpen();
  };
}
